<template>
  <div id="comp-filemng-system-directory">
    <DirectoryItem
      @click="getSystemFiles(defaultDirectory.id, defaultDirectory.name)"
      :class="{ 
          active: defaultDirectory.id == selectDirectoryID,
          imageNone: !isShowImage && defaultDirectory.id !== 'document',
        }"
      class="fs-sa-14 d-flex align-items-center"
    >
      <IconFolderOpen v-show="defaultDirectory.id == selectDirectoryID"/>
      <IconFolder v-show="defaultDirectory.id != selectDirectoryID"/>
      <span class="pl-10">{{ defaultDirectory.name }}</span>
    </DirectoryItem>
    <DirectoryItem
      @click="getSystemFiles(folder.id, folder.name)"
      :class="{
        active: folder.id == selectDirectoryID,
        document: !isShowDocument && folder.id == 'document',
        imageNone: !isShowImage && folder.id !== 'document',
      }"
      v-for="folder in siteFileDirectory"
      :key="folder.id"
      class="fs-sa-14 py-5 d-flex align-items-center"
    >
      <IconFolderOpen v-show="folder.id == selectDirectoryID"/>
      <IconFolder v-show="folder.id != selectDirectoryID"/>
      <span class="px-10"> {{ folder.name }} </span>
      <span
        class="ml-auto tool"
        @click.stop.prevent="checkDeleteDirData(folder.id)"
        v-if="folder.name !== 'Document'"
      >
        <i class="far fa-trash-alt"></i>
      </span>
    </DirectoryItem>
    <ConfirmDelete @confirmed="deleteDir()" @clear="dir_id = ''" />
  </div>
</template>

<script>
import { DirectoryItem } from "./Filemanager.styled";
import fileService from "@services/fileService.js";
import ConfirmDelete from "./modal/ConfirmDelete.vue";
import IconFolder from "@components_system/Shared/Images/Icon/Folder.vue";
import IconFolderOpen from "@components_system/Shared/Images/Icon/FolderOpen.vue";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      dir_id :undefined,
    }
  },
  components: {
    DirectoryItem,
    ConfirmDelete,
    IconFolder,
    IconFolderOpen,
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      }),
    getTextFilter() {
      const filter = this.categories.filter((category) => {
        return category.id === this.options.categoryID
        });
      return filter && filter[0] && filter[0].name;
		},
	},
  methods: {
    getSystemFiles(id, name) {
      this.$emit("callback", { id, name });
    },
    checkDeleteDirData(directoryID) {
      const option = {
        p: 1,
        take: 1,
        name: "",
      };
      fileService.getFiles(directoryID, option).then((result) => {
        if (result.totalCount > 0) {
          this.$bvModal.show("modal-cannot-delete-dir");
        } else {
          this.dir_id = directoryID;
          this.$bvModal.show("modal-confirm-delete-dir");
        }
      });
    },
    deleteDir() {
      fileService.deleteDirectory(this.dir_id).then((result) => {
        if (result.success) {
          this.$toast.success({ title: this.$t("engine.common.alert.success.title", this.languageEngine), message: this.$t("engine.filemanager.alert.deleteFolder.success", this.languageEngine) });
          this.$emit('getSystemDirectories')
          this.dir_id = "";
        } else if (result.data.error === "ERROR_FILEMANAGER_DIR_IS_NOT_EMPTY") {
          this.$toast.error({ title: this.$t("engine.common.alert.error.title", this.languageEngine), message:this.$t("engine.filemanager.alert.deleteFolder.fail", this.languageEngine) });
          this.$bvModal.show("modal-cannot-delete-dir");
        } else {
          this.$toast.error({ title: this.$t("engine.common.alert.error.title", this.languageEngine), message:this.$t("engine.filemanager.alert.deleteFolder.fail", this.languageEngine) });
        }
      });
    },
  },
  props: {
    defaultDirectory: {
      type: Object,
      default: () => {},
    },
    selectDirectoryID: {
      type: [Number, String],
      default: 0,
    },
    siteFileDirectory: {
      type: Array,
      default: () => [],
    },
    isShowDocument: {
      type: Boolean,
      default: false,
    },
    isShowImage: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
